import "./App.css";
import Login from "./authentication/Login";
import NewPassword from "./authentication/NewPassword";
import OTP from "./authentication/OTP";
import ResetPassword from "./authentication/ResetPassword";
import Sidenav from "./dashboard/Sidenav";
import RequireAuth from "./components/RequireAuth";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Missing from "./other/Missing";
import Unauthorised from "./other/Unauthorised";
import PersistLogin from "./components/PersistLogin";
import Home from "./dashboard/Home";
import Tenants from "./pages/Tenants";
import Admins from "./pages/Admins";
import TenantWorkers from "./pages/TenantWorkers";
import Jobs from "./pages/Jobs";
import Speciality from "./pages/Speciality";
import Roles from "./pages/Roles";
import Status from "./pages/Status";
import Locations from "./pages/Locations";
import PaymentModes from "./pages/PaymentModes";
import TenantAdmins from "./pages/TenantsAdmins";
import Profile from "./pages/Profile";
import Faqs from "./pages/Faqs";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        {/* public routes */}
        <Route path="login" element={<Login />} />
        <Route path="otp" element={<OTP />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="new-password" element={<NewPassword />} />
        <Route path="unauthorised" element={<Unauthorised />} />

        {/* Add Linkage route */}
        {/* Protected routes: Only Managers(1) & Admins(2) */}
        <Route element={<PersistLogin />}>
          <Route element={<RequireAuth allowedRoles={[1, 2]} />}>
            <Route element={<Sidenav />}>
              <Route path="/" element={<Home />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="admins" element={<Admins />} />
              <Route path="tenant-admins" element={<TenantAdmins />} />
              <Route path="workers" element={<TenantWorkers />} />
              <Route path="specialities" element={<Speciality />} />
              <Route path="roles" element={<Roles />} />
              <Route path="status" element={<Status />} />
              <Route path="locations" element={<Locations />} />
              <Route path="payment-modes" element={<PaymentModes />} />
              <Route path="tenants" element={<Tenants />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/faqs" element={<Faqs />} />
            </Route>
          </Route>
        </Route>

        {/* Catch all */}
        <Route path="*" element={<Missing />} />
      </Route>
    </Routes>

    /* <>
      <Routes>
        <Route path='/' element={<Login />}/>
        <Route path='sidenav' element={<Sidenav />}/>
        <Route path='reset-password' element={<ResetPassword />}/>
        <Route path='otp' element={<OTP />}/>
      </Routes>
    </> */
  );
}

export default App;
